import { Renderer } from "@/core/pipeline/renderer"

export abstract class RenderPass {
	public id: string
	protected renderer: Renderer

	constructor(renderer: Renderer, id: string) {
		this.renderer = renderer
		this.id = id
	}

	abstract render(..._: any[]): void

	abstract dispose(): void
}
